import React, { useRef } from "react";

import { Button, Popover, Stack, TextField } from "@mui/material";

import { CommentPopup, useGroupsForm } from "./GroupsFormContext";

interface Props extends CommentPopup {}

export const CommentsPopover: React.FC<Props> = ({ anchorEl, initialValue, measureDataKey }) => {
  const { setCommentPopup, updateMeasureData } = useGroupsForm();

  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = () => {
    if (!inputRef.current) return;
    const value = inputRef.current.value.trim();
    if (value !== initialValue) {
      updateMeasureData({ key: measureDataKey, description: value });
    }
    setCommentPopup(null);
  };

  return (
    <Popover open anchorEl={anchorEl} onClose={() => setCommentPopup(null)}>
      <Stack sx={{ p: "20px" }}>
        <TextField
          inputRef={inputRef}
          defaultValue={initialValue}
          multiline
          sx={{
            marginBottom: "15px",
            flexGrow: 1,
            ".MuiOutlinedInput-root": {
              "& > fieldset": { borderColor: "rgba(93, 119, 130, 0.6)" }
            }
          }}
          label="Description"
          minRows={3}
          maxRows={Infinity}
        />
        <Stack direction="row" gap="10px">
          <Button variant="outlined" onClick={() => setCommentPopup(null)}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained">
            Save
          </Button>
        </Stack>
      </Stack>
    </Popover>
  );
};
